import { useContext, useState, useEffect } from "react";
import  { I18nextContext } from "gatsby-plugin-react-i18next";
import { useLocation } from "@reach/router";

const useI18nLocation = () => {
  const loc = useLocation();
  const { originalPath } = useContext(I18nextContext);
  // find first part of originalPath and search in loc.pathname
  const getNewPathname = (op: string) => {
    const originalPathFirstSegment = op.split("/")[1];
    const segIdx = loc.pathname.search("/" + originalPathFirstSegment);
    // Cut the part before segIdx
    return loc.pathname.slice(segIdx);
  }
  const originalLoc ={
    ...loc,
    pathname: getNewPathname(originalPath),
  };
  const [newLoc, setNewLoc] = useState(originalLoc);
  useEffect(() => {
    const newNewLoc = {
      ...loc,
      pathname: getNewPathname(originalPath),
    }
    setNewLoc(newNewLoc)
  }, [loc.hash, loc.search, originalPath])

  return newLoc;
};

export default useI18nLocation;